import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './styles.scss';

const EpAvatar = () => {
  const user = useSelector(state => state.auth.user);
  const [userInitials, setUserInitials] = useState('');

  function getUserInitials() {
    if (user) {
      const userFirstName = user ? user.given_name.split(' ')[0] : '';
      const userLastName = user ? user.given_name.split(' ')[1] : '';

      const userInitialFirstName = userFirstName ? userFirstName.substr(0, 1) : '';
      const userInitialLastName = userLastName ? userLastName.substr(0, 1) : '';

      setUserInitials(`${userInitialFirstName}${userInitialLastName}`);
    }
  }

  useEffect(() => {
    getUserInitials();
  }, [user]);

  return (
    <div className="rounded-circle navigation__dropdown-link-avatar">
      <span className="navigation__dropdown-link-avatar-initials">
        {userInitials}
      </span>
    </div>
  );
};

export default EpAvatar;
